'use client';

import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useState } from 'react';
import { Link } from '../Link';
import { FormattedName } from '../Name';
import { BlogNavLink, Logo, LogoText, MobileMenuButton, Nav, NavContainer, NavLink, NavLinks } from './NavBar.components';

export function NavBar(props: {
	readonly doBlog: boolean;
}) {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const toggleMenu = useCallback(() => {
		setIsMenuOpen((prev) => !prev);
	}, []);

	const closeMenu = useCallback(() => {
		setIsMenuOpen(false);
	}, []);

	return <Nav>
		<NavContainer>
			<Logo>
				<Link href="/" onClick={closeMenu}>
					<LogoText><FormattedName desiredFormat='first last' fallbackFormat='nickname' /></LogoText>
				</Link>
			</Logo>

			<MobileMenuButton
				type="button"
				onClick={toggleMenu}
				aria-expanded={isMenuOpen}
				aria-label="Toggle navigation menu"
			>
				<FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
			</MobileMenuButton>

			<NavLinks className={isMenuOpen ? 'open' : ''}>
				<NavLink>
					<Link href="/" onClick={closeMenu} prefetch>
						Home
					</Link>
				</NavLink>
				{!props.doBlog ? null : <BlogNavLink>
					<Link href="/blog" onClick={closeMenu} prefetch>
						Blog
					</Link>
				</BlogNavLink>
				}
				<NavLink>
					<Link href="/#projects" onClick={closeMenu} prefetch>
						Projects
					</Link>
				</NavLink>
				<NavLink>
					<Link href="/for-employers" onClick={closeMenu} prefetch>
						For Employers
					</Link>
				</NavLink>
			</NavLinks>
		</NavContainer>
	</Nav>;
}
